const actions = {
  SET_STATE: 'investorVerification/SET_STATE',
  CHANGE_INVESTOR_NAME: 'investorVerification/CHANGE_INVESTOR_NAME',
  FETCH_ACTIVE_INVITATIONS: 'investorVerification/FETCH_ACTIVE_INVITATIONS',
  ON_DECLINE_INVESTOR: 'investorVerification/ON_DECLINE_INVESTOR',
  ON_APPROVE_INVESTOR: 'investorVerification/ON_APPROVE_INVESTOR',
}

export default actions
